export enum CatalogLayoutEditStatus {
    Unchanged = 0,
    Changed = 2,
    Deleted = 3,
    New = 4
}
